import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { setAccessToken, setUnidadeIdCookie, setUnitAccessToken } from "../../funcs";
import { jwtDecode } from "jwt-decode";
import apiUnidade from "../../services/apis/apiUnidade";

export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      const params = new URLSearchParams(window.location.search);
      const token = params.get("token");
  
      if (token) {
        const decode = jwtDecode(token); 
        setAccessToken(token);
        const unidadeId = decode.unidadeId;
        const ujwt = (await apiUnidade.selecionarUnidade(unidadeId)).data;
        setUnidadeIdCookie(unidadeId);
        window.dispatchEvent(new Event("storage"));
        setUnitAccessToken(ujwt);
        
        window.location.href = "/monitoramento/geral";
      } 
    })();

    const timer = setTimeout(() => navigate("/"), 1000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      fontSize: "1.2rem"
    }}>
      Carregando...
    </div>
  );
}
